import { apiRequests } from '../utilities/axios-factory'
import store from '../store'

function findOcppChargers ({ where, limit, offset, order, search, bounds } = {}) {
  return apiRequests.get('/v1/ocpp-charger/', {
    params: {
      where,
      limit,
      skip: offset,
      order,
      search,
      bounds
    },
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

function findTotalOcppChargers ({ where, search, bounds } = {}) {
  return apiRequests.get('/v1/ocpp-charger/count/', {
    params: { where, search, bounds },
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

function getOcppCharger ({ id }) {
  return apiRequests.get('/v1/ocpp-charger/' + id + '/', {
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

function createOcppCharger (data) {
  return apiRequests.post('/v1/ocpp-charger/', data, {
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

function updateOcppCharger (data) {
  const payload = Object.assign({}, data)
  delete payload.id
  return apiRequests.patch('/v1/ocpp-charger/' + data.id + '/', payload, {
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

function deleteOcppCharger ({ id }) {
  return apiRequests.delete('/v1/ocpp-charger/' + id + '/', {
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

function setChargerCredential ({ id, password, pushToCharger }) {
  return apiRequests.post('/v1/ocpp-charger/' + id + '/credential', {
    password,
    pushToCharger
  }, {
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

function clearChargerCredential ({ id }) {
  return apiRequests.delete('/v1/ocpp-charger/' + id + '/credential', {
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

function debugPopulateOcppChargerBootData ({ id }) {
  return apiRequests.post('/v1/ocpp-charger/' + id + '/debug-boot-data', {}, {
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

function listEmulatorChargers () {
  return apiRequests.get('/v1/ocpp-charger/emulator/chargers', {
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

function getEmulatorCharger ({ chargePointId }) {
  return apiRequests.get('/v1/ocpp-charger/emulator/chargers/' + encodeURIComponent(chargePointId), {
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

function connectEmulatorCharger ({ chargePointId }) {
  return apiRequests.post('/v1/ocpp-charger/emulator/chargers/' + encodeURIComponent(chargePointId) + '/connect', {}, {
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

function disconnectEmulatorCharger ({ chargePointId }) {
  return apiRequests.post('/v1/ocpp-charger/emulator/chargers/' + encodeURIComponent(chargePointId) + '/disconnect', {}, {
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

function setEmulatorOffline ({ chargePointId }) {
  return apiRequests.post('/v1/ocpp-charger/emulator/chargers/' + encodeURIComponent(chargePointId) + '/offline', {}, {
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

function setEmulatorOnline ({ chargePointId }) {
  return apiRequests.post('/v1/ocpp-charger/emulator/chargers/' + encodeURIComponent(chargePointId) + '/online', {}, {
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

function startEmulatorTransaction ({
  chargePointId,
  connectorId,
  idTag,
  profile,
  initialEnergyWh
}) {
  return apiRequests.post('/v1/ocpp-charger/emulator/chargers/' + encodeURIComponent(chargePointId) + '/start-transaction', {
    connectorId,
    idTag,
    profile,
    initialEnergyWh
  }, {
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

function sendEmulatorMeterValues ({ chargePointId, intervalSeconds, timestamp }) {
  return apiRequests.post('/v1/ocpp-charger/emulator/chargers/' + encodeURIComponent(chargePointId) + '/meter-values', {
    intervalSeconds,
    timestamp
  }, {
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

function setEmulatorAutopilot ({ chargePointId, on, profile, intervalSeconds }) {
  return apiRequests.post('/v1/ocpp-charger/emulator/chargers/' + encodeURIComponent(chargePointId) + '/autopilot', {
    on,
    profile,
    intervalSeconds
  }, {
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

function stopEmulatorTransaction ({
  chargePointId,
  reason,
  timestamp,
  meterStopWh,
  includeFinalMeterSample,
  intervalSeconds
}) {
  return apiRequests.post('/v1/ocpp-charger/emulator/chargers/' + encodeURIComponent(chargePointId) + '/stop-transaction', {
    reason,
    timestamp,
    meterStopWh,
    includeFinalMeterSample,
    intervalSeconds
  }, {
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

function getEmulatorReceivedCommands ({ chargePointId }) {
  return apiRequests.get('/v1/ocpp-charger/emulator/chargers/' + encodeURIComponent(chargePointId) + '/received-commands', {
    headers: { Authorization: store.getters.getTokenId }
  }).then((result) => result.data)
}

function getOcppChargerTemplate () {
  return {
    chargePointId: '',
    status: 'Offline',
    agencyId: null,
    locationLabel: '',
    timezone: null,
    latitude: null,
    longitude: null,
    metadata: {}
  }
}

export {
  findOcppChargers,
  findTotalOcppChargers,
  getOcppCharger,
  createOcppCharger,
  updateOcppCharger,
  deleteOcppCharger,
  setChargerCredential,
  clearChargerCredential,
  debugPopulateOcppChargerBootData,
  listEmulatorChargers,
  getEmulatorCharger,
  connectEmulatorCharger,
  disconnectEmulatorCharger,
  setEmulatorOffline,
  setEmulatorOnline,
  startEmulatorTransaction,
  sendEmulatorMeterValues,
  setEmulatorAutopilot,
  stopEmulatorTransaction,
  getEmulatorReceivedCommands,
  getOcppChargerTemplate
}
